import { PackageVersion } from "../../booking-create-page/booking-create-page.types";
import { format, isBefore, startOfMonth } from "date-fns";

export function getUpsellBeginDate(
  cycle: PackageVersion | undefined,
  contractStartDate: string,
): string {
  if (!cycle || cycle.status === "active") {
    if (isBefore(new Date(contractStartDate), startOfMonth(new Date()))) {
      return format(startOfMonth(new Date()), "yyyy-MM-dd");
    }
    return contractStartDate;
  }

  // A mid-month beginDate makes the backend pro-rate the first payment,
  // so future cycles must send their exact start date.
  return cycle.startDate.split("T")[0];
}
